// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tierOverviewCard__FkmbS {
  margin-bottom: 1.5rem;
  padding: 1.25rem 1.5rem; }

.styles_tierOverviewTitle__dnyaV {
  margin-bottom: 0.5rem;
  font-size: 1.25rem; }

.styles_tierOverviewDescription__tGyiU {
  color: #808080b8;
  font-size: 1rem;
  line-height: 1.5; }

.styles_tierOverviewCoaching__qxyw9 {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background: #80808012;
  border-radius: 0.5rem;
  border-left: 3px solid #72abab; }

.styles_tierOverviewCoachingText__BhlIK {
  font-size: 0.95rem;
  color: #808080e6; }

.styles_contentContainer__jSZf6 {
  height: 75%;
  width: 100%; }

.styles_headerContainer__Ye1xQ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  position: relative;
  height: 10rem;
  margin-bottom: 1rem; }
  .styles_headerContainer__Ye1xQ .styles_header__jYdvJ {
    width: 80%;
    margin-top: unset;
    height: unset; }

.styles_cancelButton__phF\\+J {
  padding: 0.5rem 2rem !important; }

.styles_cancelledStamp__Sa81s {
  position: absolute;
  height: 2rem;
  top: calc(50%);
  transform: translateY(-50%);
  right: 0;
  color: #dc2626 !important;
  border-color: #dc2626 !important;
  border-width: 3px;
  border-style: dotted;
  border-radius: 10%;
  padding: 0.5rem 1rem;
  font-weight: 600;
  opacity: 0.9; }
  .styles_cancelledStamp__Sa81s p {
    color: #dc2626 !important;
    text-transform: uppercase;
    font-weight: 700; }
`, "",{"version":3,"sources":["webpack://./src/modules/membership/components/screens/membership-payments-screen/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,qBAAqB;EACrB,uBAAuB,EAAA;;AAG3B;EACI,qBAAqB;EACrB,kBAAkB,EAAA;;AAGtB;EACI,gBCIc;EDHd,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB;EAChB,qBAAqB;EACrB,qBCVa;EDWb,qBAAqB;EACrB,8BCgBgB,EAAA;;ADbpB;EACI,kBAAkB;EAClB,gBCVc,EAAA;;ADYlB;EACI,WAAW;EACX,WAAW,EAAA;;AAEf;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAA;EATvB;IAWQ,UAAU;IACV,iBAAiB;IACjB,aAAa,EAAA;;AAIrB;EACI,+BAA+B,EAAA;;AAGnC;EACI,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,QAAQ;EACR,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY,EAAA;EAbhB;IAgBQ,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.tierOverviewCard {\n    margin-bottom: 1.5rem;\n    padding: 1.25rem 1.5rem;\n}\n\n.tierOverviewTitle {\n    margin-bottom: 0.5rem;\n    font-size: 1.25rem;\n}\n\n.tierOverviewDescription {\n    color: $grey72;\n    font-size: 1rem;\n    line-height: 1.5;\n}\n\n.tierOverviewCoaching {\n    margin-top: 1rem;\n    padding: 0.75rem 1rem;\n    background: $grey7;\n    border-radius: 0.5rem;\n    border-left: 3px solid $ocean_blue;\n}\n\n.tierOverviewCoachingText {\n    font-size: 0.95rem;\n    color: $grey90;\n}\n.contentContainer {\n    height: 75%;\n    width: 100%;\n}\n.headerContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n    position: relative;\n    height: 10rem;\n    margin-bottom: 1rem;\n    .header {\n        width: 80%;\n        margin-top: unset;\n        height: unset;\n    }\n}\n\n.cancelButton {\n    padding: 0.5rem 2rem !important;\n}\n\n.cancelledStamp {\n    position: absolute;\n    height: 2rem;\n    top: calc(50%);\n    transform: translateY(-50%);\n    right: 0;\n    color: #dc2626 !important;\n    border-color: #dc2626 !important;\n    border-width: 3px;\n    border-style: dotted;\n    border-radius: 10%;\n    padding: 0.5rem 1rem;\n    font-weight: 600;\n    opacity: 0.9;\n    \n    p {\n        color: #dc2626 !important;\n        text-transform: uppercase;\n        font-weight: 700;\n    }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tierOverviewCard": `styles_tierOverviewCard__FkmbS`,
	"tierOverviewTitle": `styles_tierOverviewTitle__dnyaV`,
	"tierOverviewDescription": `styles_tierOverviewDescription__tGyiU`,
	"tierOverviewCoaching": `styles_tierOverviewCoaching__qxyw9`,
	"tierOverviewCoachingText": `styles_tierOverviewCoachingText__BhlIK`,
	"contentContainer": `styles_contentContainer__jSZf6`,
	"headerContainer": `styles_headerContainer__Ye1xQ`,
	"header": `styles_header__jYdvJ`,
	"cancelButton": `styles_cancelButton__phF+J`,
	"cancelledStamp": `styles_cancelledStamp__Sa81s`
};
export default ___CSS_LOADER_EXPORT___;
